export const VERIFICATION_STEPS = {
    SHOP_INFO: 'shop',
    DOCUMENTS: 'documents',
    LOCATION: 'location',
    FINAL_DECISION: 'decision'
}